import http from "../services/apiServices";
import config from "src/config";
import { isCivilDefenseUser } from 'src/utils/helpers';

export const getPreventiveAppointmentsApi = async (data: any) => {
   const api = isCivilDefenseUser() ? config.appointments.getCDAppointments : config.appointments.getAppointments

   var pathName = window.location.pathname;
   if (pathName && pathName.includes('breached')) {
      data.SLABreached = true;
      data.isBreached = true;
   }
   return await http.post(api, data);
};

export const updateStatusAPI = async (data: any, api: any) => {
   return await http.post(api, data);
};
export const retrieveAppointmentStatusForEditAPI = async () => {
   return await http.get(config.appointments.retrieveAppointmentStatusForEdit);
 };